export default __webpack_public_path__ + "media/color/ampl-b6306660.svg";